import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_visibility/s/$space/post/$post")({
	component: RouteComponent,
	loader: ({ params }) => {
		throw redirect({
			to: "/comunidade/s/$space/posts/$post",
			params: {
				space: params.space,
				post: params.post,
			},
		});
	},
});

function RouteComponent() {
	return null;
}
